export default __webpack_public_path__ + "434351a86f1620f8501f6a4c3f9f9869.png";